import React, { useState } from 'react';
import { MdLocationOn } from 'react-icons/md';
import Profile from '../TabProfile/Profile';
import Message from '../TabProfile/Message';
import Appointment from '../TabProfile/Appointment';
import Wishlist from '../TabProfile/Wishlist';

const ProfileCustomer = () => {
  const [activeTab, setActiveTab] = useState('profile');

  const handleFetch = () => {
    console.log('Fetch button clicked');
  };

  const tabs = [
    { id: 'profile', label: 'Profile', component: <Profile /> },
    { id: 'message', label: 'Message', component: <Message /> },
    { id: 'appointment', label: 'Appointment', component: <Appointment /> },
    { id: 'wishlist', label: 'Wishlist', component: <Wishlist /> },
  ];

  return (
    <div className="bg-[#FFF6F1] p-4 sm:p-6 lg:p-8">
      {/* Header */}
      <h1 className="text-[#1B4582] text-2xl sm:text-3xl lg:text-4xl font-bold text-center mb-6">
        Local Pet Boarder Near You
      </h1>

      {/* Pin Code Input and Fetch Button */}
      <div className="flex flex-col sm:flex-row justify-center items-center gap-3 mb-8">
        <div className="relative w-full sm:w-auto">
          <MdLocationOn className="absolute left-3 top-1/2 transform -translate-y-1/2 w-6 h-6 text-[#ffa500]" />
          <input
            type="number"
            inputMode="numeric"
            pattern="[0-9]*"
            placeholder="Enter pin code"
            className="w-full sm:w-48 pl-10 pr-4 py-2.5 border-4 border-[#dbdbe5] rounded-md focus:outline-none focus:ring-2 focus:ring-[#bbbaba] text-sm sm:text-base placeholder-[#000048] 
              [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
          />
        </div>
        <button
          onClick={handleFetch}
          className="w-full sm:w-auto bg-[#FF6216] text-white px-5 py-2.5 font-semibold rounded-md hover:bg-[#e05514] transition duration-150 flex items-center gap-2 text-base sm:text-lg"
        >
          Fetch <span className="text-xl font-bold">→</span>
        </button>
      </div>

      {/* Tabs */}
      <div className="flex flex-wrap gap-2 sm:gap-7 px-4 mb-6">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`px-4 py-2 sm:px-5 sm:py-2.5 font-semibold rounded-md text-base sm:text-lg transition duration-150 flex items-center gap-2 ${
              activeTab === tab.id
                ? 'bg-[#1B4582] text-white shadow-md'
                : 'bg-gray-200 text-[#1B4582] hover:bg-gray-300'
            }`}
            role="tab"
            aria-selected={activeTab === tab.id}
            aria-controls={`panel-${tab.id}`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="px-4">
        {tabs.map((tab) => (
          <div
            key={tab.id}
            id={`panel-${tab.id}`}
            role="tabpanel"
            className={activeTab === tab.id ? 'block' : 'hidden'}
          >
            {tab.component}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProfileCustomer;